/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Cost } from '../models/Cost';
import { MeteringDimension } from '../models/MeteringDimension';
import { Usage } from '../models/Usage';

/**
* Cost and usage breakdown for a specific metering dimension. 
*/
export class CostDataRecordCost {
  'meteringDimension': MeteringDimension;
  'cost': Cost;
  'usage': Usage;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "meteringDimension",
      "baseName": "meteringDimension",
      "type": "MeteringDimension",
      "format": ""
    },
    {
      "name": "cost",
      "baseName": "cost",
      "type": "Cost",
      "format": ""
    },
    {
      "name": "usage",
      "baseName": "usage",
      "type": "Usage",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CostDataRecordCost.attributeTypeMap;
  }

  public constructor() {
  }
}



